/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var ColumnSortDescription = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnSortDescription, _super);
    function ColumnSortDescription(a) {
        var _rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _rest[_i - 1] = arguments[_i];
        }
        var _this = _super.call(this) || this;
        _this.e = null;
        _this.b = 0;
        a = (a == void 0) ? 0 : a;
        switch (a) {
            case 0: break;
            case 1:
                {
                    var c = _rest[0];
                    _this.f = c;
                }
                break;
            case 2:
                {
                    var c = _rest[0];
                    var d = _rest[1];
                    _this.f = c;
                    _this.c = d;
                }
                break;
        }
        return _this;
    }
    Object.defineProperty(ColumnSortDescription.prototype, "f", {
        get: function () {
            return this.e;
        },
        set: function (a) {
            this.e = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnSortDescription.prototype, "c", {
        get: function () {
            return this.b;
        },
        set: function (a) {
            this.b = a;
        },
        enumerable: true,
        configurable: true
    });
    ColumnSortDescription.prototype.equals = function (a) {
        var b = a;
        if (b == null) {
            return _super.prototype.equals.call(this, a);
        }
        return b.f == this.f && b.c == this.c;
    };
    ColumnSortDescription.prototype.getHashCode = function () {
        return Base.getHashCodeStatic(this.f) * 17 + this.c;
    };
    ColumnSortDescription.$t = markType(ColumnSortDescription, 'ColumnSortDescription');
    return ColumnSortDescription;
}(Base));
export { ColumnSortDescription };
//# sourceMappingURL=ColumnSortDescription.js.map
